<template>
  <div class="fertilizer">
    <div class="box">
      <img
        src="./utenkluss.gif"
        width="379"
        height="381"
        alt="Som et lyn gjennem by'n. Uten Kluss med trikk og buss."
      >
    </div>
    <div class="updated">27 XI 2007</div>
  </div>
</template>

<script>
export default {
  name: "utenkluss"
};
</script>

<style scoped>
.fertilizer {
  background-color: #fff;
}

.box {
  margin-top: -190px;
}

.updated {
  color: #c0c0c0;
}
</style>
